
export const DepositSummary = ({ checkInData }) => {
  return (
    <div className="deposit-summary-wrapper">

 <h6 className="flexRow justifyContentFlexStart normal-button-text-medium margTop16">Deposit Details</h6>
           <div className='table-header'></div>
      <table className="currency-table">
        <thead>
          <tr>
            <th>Currency Code</th>          
            <th>Value</th>
          </tr>
        </thead>

        <tbody>
          {checkInData?.map(row => (
            <tr key={row.currencyCode}>
              <td >{row.currencyCode}</td>
              <td >{row.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
 </div>

  );
};
